module.exports = __webpack_public_path__ + "img/ic_social_apple.85f4a002.svg";